import { render, staticRenderFns } from "./DtPopup.vue?vue&type=template&id=81764fd6"
import script from "./DtPopup.vue?vue&type=script&lang=js"
export * from "./DtPopup.vue?vue&type=script&lang=js"
import style0 from "./DtPopup.vue?vue&type=style&index=0&id=81764fd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports